export enum VerifyEmailErrors {
  TOKEN_EXPIRED = 'tokenExpired',
  TOKEN_INVALID = 'tokenInvalid',
  EMAIL_CHANGE_ERROR = 'emailChangeError',
}
